export enum CognitoError {
  NO_CURRENT_USER = 'No current user',
  REFRESH_TOKEN_EXPIRED = 'Refresh Token has expired',
}
